import React from 'react';
import AiTrainingDataContext from '../AiTrainingDataContext';
import useAiTrainingData from '../useAiTrainingData';
//import AiTrainingDataLibrary from '../Components/AiTrainingDataContent';
import CateringContext from '../../Catering/CateringContext';
import useCatering from '../../Catering/useCatering';
import { Outlet } from 'react-router';
import AiTrainingDataContent from './AiTrainingDataContent';

function AiTrainingDataRoot() {
    const aiTrainingDataHook = useAiTrainingData();
    const cateringHook = useCatering();

    return (
        <AiTrainingDataContext.Provider value={aiTrainingDataHook}>
            <CateringContext.Provider value={cateringHook}>
                <AiTrainingDataContent>
                    <Outlet />
                </AiTrainingDataContent>
            </CateringContext.Provider>
        </AiTrainingDataContext.Provider>
    );
}

AiTrainingDataRoot.propTypes = {};

export default AiTrainingDataRoot;
